module.exports = __webpack_public_path__ + "fonts/onprem_70x70.5e05526b84decb735a4c46c552eeb73b.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/onprem_70x70.png
// module id = 770
// module chunks = 9